/* eslint-disable no-shadow */
import React, { useEffect, useState, useRef } from 'react'
import { message, Select, Radio } from 'antd'
import cloneDeep from 'lodash/cloneDeep'
import { List, arrayMove } from 'react-movable'
import classnames from 'classnames'
import yearImg from 'image/image_year.png'
import monthImg from 'image/image_month.png'
import dayImg from 'image/image_day.png'
import { teamHasAuth } from 'meinian-package/src/utils/auth'
import Checkbox from 'meinian-package/src/baseComponent/checkbox'
import Modal from 'meinian-package/src/component/modal'
import Input from 'meinian-package/src/baseComponent/input'
import Switch from 'meinian-package/src/baseComponent/switch'
import Icon from 'meinian-package/src/component/icon'
import mes from 'meinian-package/src/utils/message'
import request from 'meinian-package/src/utils/request'
import { Loading, Dropdown } from 'meinian-package/src/baseComponent'
import Button from 'meinian-package/src/baseComponent/button'
import Tooltip from 'meinian-package/src/baseComponent/tooltip'
import { MEMBER_TYPE } from 'meinian-package/src/component/enum'
import TreeList from '../treeList'
import './index.less'

const { Option } = Select

let iTreeKey = 0

export const TYPE = {
  TEXT: 1,
  TAG: 2,
  NUM: 3,
  LINK: 4,
  BOOL: 5,
  SINGLE: 6,
  MULTIPLE: 7,
  DATE: 8,
  MEMBER: 9
}
const PROPS_TYPE = [
  { label: '纯文本', type: 1 },
  { label: '文本标签', type: 2 },
  { label: '数字', type: 3 },
  { label: '超链接', type: 4 },
  { label: '布尔值（是/否）', type: 5 },
  { label: '单项选择', type: 6 },
  { label: '多项选择', type: 7 },
  { label: '日期', type: 8 },
  { label: '成员选择', type: 9 },
]

export const convert = (data = [], id = 0, node = 0) => {
  let i = (10 * (node || 0))
  data.forEach((root) => {
    root.node = node ? node + 1 : 1
    root.tempId = `${id ? `${id}-` : ''}${i++}`
    root.key = root.tempId
    root.fatherId = id ?? undefined
    let children = root.childItems
    if (children.length > 0) {
      children = convert(children, root.tempId, root.node)
    }
  })
  return data
}
const GENDER_LIST = ['女装', '男装', '男童', '女童', '童装', '鞋靴', '其他']
let globalFlag
let globalValueFlag

export default ({ teamInfo, type, gender, title }) => {
  const [visible, setVisible] = useState(false)
  return <div>
    {
    teamHasAuth('meinian_blog_property') && <div
      style={{ fontSize: 12, fontWeight: 400, color: '#333' }}
      onClick={() => {
        if (teamInfo.memberType !== MEMBER_TYPE.SUPER_ADMIN && teamInfo.memberType !== MEMBER_TYPE.ADMIN) {
          return message.warning('仅管理员可操作')
        }
        setVisible(true)
      }}
    >
      自定义属性
      <Icon type="m-zidingyi" style={{ marginLeft: 4 }} />
    </div>
  }
    <CustomAttributeModal
      visible={visible}
      title={title}
      type={type}
      gender={gender}
      onClose={() => setVisible(false)}
    />
  </div>
}

const CustomAttributeModal = ({ type, gender, visible, onClose, title = '添加自定义属性' }) => {
  return <Modal
    centered
    visible={visible}
    hiddenCloseIcon
    hiddenFooter
    wrapStyle={{ zIndex: 1001 }}
    style={{ width: 'unset' }}
    className="meinian-defined-props-modal"
  >
    <UserDefinedPropsContent type={type} gender={gender} onClose={onClose} title={title} />
  </Modal>
}

export const UserDefinedPropsContent = ({ type, gender, className, onClose, title = '添加自定义属性' }) => {
  const [currentGender, setCurrentGender] = useState()
  const [propsList, setPropsList] = useState()
  const [showEdit, setShowEdit] = useState(false)
  const [showEditList, setShowEditList] = useState(false)
  const [current, setCurrent] = useState()
  const [dropVisible, setDropVisible] = useState(false)
  const [loading, setLoading] = useState(false)
  const [emptyList, setEmptyList] = useState()
  const defaultList = useRef()
  const $propertyBottom = useRef()

  useEffect(() => {
    setCurrentGender(gender || '女装')
  }, [gender])

  useEffect(() => {
    if (!currentGender) return
    setShowEdit(false)
    setShowEditList(false)
    fetchDefaultProperty()
    fetchPropertyList()
  }, [currentGender, type])

  useEffect(() => {
    const { propertyType } = current || {}
    if (propertyType === TYPE.SINGLE) {
      if (current.singleStruct.rootItems.length > 0) {
        setShowEditList(true)
        return
      }
    }
    if (propertyType === TYPE.MULTIPLE) {
      if (current.multiStruct.rootItems.length > 0) {
        setShowEditList(true)
        return
      }
    }
    setShowEditList(false)
  }, [current])
  useEffect(() => {
    // eslint-disable-next-line no-shadow
    const emptyList = []
    propsList?.forEach((prop) => {
      if (prop.propertyType === TYPE.SINGLE || prop.propertyType === TYPE.MULTIPLE) {
        const list = prop.propertyType === TYPE.SINGLE ? prop.singleStruct.rootItems : prop.multiStruct.rootItems
        let flag = false
        loop(list, () => {
          flag = true
        })
        if (flag) {
          emptyList.push(prop.propertyId)
        }
      }
    })
    setEmptyList(emptyList)
  }, [propsList])
  const fetchDefaultProperty = async () => {
    const res = await request.get('/zhikuan/mn/property/default', { params: { targetType: type, gender: currentGender } })
    defaultList.current = res.filter(m => m.isFixed)
  }
  const fetchPropertyList = async () => {
    setLoading(true)
    const res = await request.get('/zhikuan/mn/property/list', { params: { targetType: type, gender: currentGender } })
    setPropsList(res)
    setLoading(false)
  }
  const loop = (data, callback) => {
    for (let i = 0; i < data.length; i++) {
      if (!data[i].value || /[\^|=]/.test(data[i].value)) {
        return callback()
      }
      if (data[i].childItems.length > 0) {
        loop(data[i].childItems, callback)
      }
    }
  }
  const loopPropertyList = (data) => {
    for (let i = 0; i < data.length; i++) {
      delete data[i].title
      if (data[i].childItems.length > 0) {
        loopPropertyList(data[i].childItems)
      }
    }
  }
  // 保存自定义属性
  const onSaveDefinedProperty = async () => {
    let flag = false
    let emptyValueFlag = false
    if (globalFlag) {
      return message.error('属性名称不能重复')
    }
    propsList.forEach((prop) => {
      if (!prop.propertyName || /[\^|=]/.test(prop.propertyName) || !prop.propertyType) {
        flag = true
      }

      if (prop.propertyType === TYPE.SINGLE || prop.propertyType === TYPE.MULTIPLE) {
        const list = prop.propertyType === TYPE.SINGLE ? prop.singleStruct.rootItems : prop.multiStruct.rootItems
        if (list.length === 0) {
          emptyValueFlag = true
          return
        }
        loop(list, () => {
          emptyValueFlag = true
        })
      }

      if (prop.tempId) {
        delete prop.propertyId
        delete prop.tempId
      }
    })

    if (emptyValueFlag) {
      message.error('属性值不能为空，且不能包含「^」和「=」')
    }

    if (flag) {
      message.error('属性名称和属性类型不能为空， 且属性名称不能包含字符「^」和「=」')
      flag = false
      return
    }

    if (globalValueFlag) {
      return message.error('同一级选项的名称不能重复')
    }
    if (flag || emptyValueFlag) return
    propsList.forEach((prop) => {
      if (prop.propertyType === TYPE.SINGLE || prop.propertyType === TYPE.MULTIPLE) {
        const list = prop.propertyType === TYPE.SINGLE ? prop.singleStruct.rootItems : prop.multiStruct.rootItems
        loopPropertyList(list)
      }
    })
    try {
      const res = await request.post('/zhikuan//mn/property/save', {
        gender: currentGender,
        propertyItems: propsList,
        targetType: type // 样衣为2
      })
      if (res) {
        message.success('保存成功')
        mes.pub('MNDefinedProperty')
        setCurrent({})
        onClose?.()
      }
    } catch (err) {
      console.error(err)
    }
  }

  const onAddProperty = () => {
    const item = { propertyName: '', isVisible: true, propertyId: new Date().getTime(), tempId: new Date().getTime() }
    propsList.push(item)
    setPropsList([...propsList])
    $propertyBottom.current.scrollIntoView()
  }
  const onRemoveProperty = (id) => {
    const list = propsList.filter(m => m.propertyId !== id)
    setPropsList([...list])
    setShowEdit(false)
    setShowEditList(false)
  }
  const onSortListChange = ({ oldIndex, newIndex }) => {
    setPropsList(arrayMove(propsList, oldIndex, newIndex))
  }
  return <div className={classnames('mn-defined-props-container', className)} style={{ display: 'flex' }}>
    <div className="module">
      <div className="header">
        <span className="title">{title}</span>
        <div className="meinian-space" />
        <Dropdown
          trigger="hover"
          overlay={<span
            className="gender-wrap"
          >
            {GENDER_LIST.map(m => <div className={classnames('gender-item fill-white-bg', { active: m === currentGender })} onClick={() => setCurrentGender(m)}>{m}</div>)}
          </span>}
          getPopupContainer={trigger => trigger}
          visible={dropVisible}
          onVisibleChange={_visible => setDropVisible(_visible)}
        >
          <span className="gender-list">{currentGender}<Icon type="m-Vxing_xia" /></span>
        </Dropdown>
      </div>
      <div className="property-info-container">
        <Loading spinning={loading} wrapperClassName="mn-defined-property-loading">
          {propsList?.length > 0 ? <List
            values={propsList}
            onChange={data => onSortListChange(data)}
            renderList={({ children, props }) => <div className="mn-props-wrap" {...props}>{children}</div>}
            renderItem={({ value, props }) => <PropertyItem
              propertyName={value?.propertyName}
              emptyList={emptyList}
              propertyId={value?.propertyId}
              key={value?.propertyId}
              isVisible={value?.isVisible}
              active={value?.propertyId === current?.propertyId}
              sortProps={props}
              onChangeStatus={(isChecked) => {
                value.isVisible = isChecked
                if (!isChecked) {
                  const index = propsList.indexOf(value)
                  propsList.splice(index, 1)
                  propsList.push(value)
                }
                setPropsList(pre => [...pre])
              }}
              propsList={propsList}
              onClickItem={() => {
                setShowEdit(true)
                setCurrent(propsList.find(m => m.propertyId === value?.propertyId))
              }}
            />}
          /> : <div style={{ flex: 1 }} />}
        </Loading>
        <div style={{ width: '100%', height: 48 }} ref={$propertyBottom} />
      </div>
      {/* 新增 */}
      <div className="add-property-btn" onClick={() => onAddProperty()}><Icon type="m-tianjia_tianchong" style={{ color: 'var(--m-success-normal)' }} /> 新增属性</div>
      <div className="meinian-space" />
      <div className="footer-btn-wrap">
        <button
          type="button"
          className="footer-btn cancel"
          onClick={() => {
            onClose?.()
            setCurrent({})
          }}
        >取消</button>
        <button
          type="button"
          className="footer-btn ok"
          onClick={() => { onSaveDefinedProperty() }}
        >保存</button>
      </div>
    </div>
    {showEdit && <PropertyEdit
      showEditList={showEditList}
      setShowEditList={setShowEditList}
      current={current}
      propsList={propsList}
      setPropsList={setPropsList}
      onRemoveProperty={onRemoveProperty}
      onClick={() => setShowEditList(!showEditList)}
    />}
    {showEditList && <AddItemList
      current={current}
      setCurrent={setCurrent}
      setPropsList={setPropsList}
      defaultList={defaultList.current}
    />}
  </div>
}

const DATE_VIEW = {
  YEAR: 1,
  MONTH: 2,
  DAY: 3
}
const PropertyItem = (props) => {
  const { propertyName, isVisible, active, sortProps, emptyList, propertyId } = props
  const [isChecked, setIsChecked] = useState(true)
  useEffect(() => {
    setIsChecked(isVisible)
  }, [isVisible])

  return <div
    className={classnames('meinian-user-defined-props-item', { active, empty: emptyList?.includes(propertyId) })}
    {...sortProps}
  >
    <Tooltip
      title="拖动调整位置"
      placement="top"
      overlayClassName="property-move-desc"
    >
      <Icon type="m-tuodong" style={{ fontSize: 24, marginLeft: 4 }} />
    </Tooltip>
    <a className="switch-wrap" onClick={e => e.stopPropagation()}><Switch
      active={isChecked}
      onChange={(isChecked) => {
        setIsChecked(isChecked)
        props.onChangeStatus(isChecked)
      }}
    /></a>
    <a className="property-info-wrap" onClick={(e) => { e.stopPropagation(); props.onClickItem() }}>
      <span className={classnames('property-name', { active: isChecked })}>{propertyName || '新属性'}</span>
      <div style={{ flex: 1 }} />
      <Icon type="m-Vxing_you" />
    </a>
  </div>
}
const PropertyEdit = (props) => {
  const { current, onClick, showEditList, onRemoveProperty, propsList, setPropsList, setShowEditList } = props
  const { propertyName, propertyType, propertyId, isFixed, tempId } = current
  const [visible, setVisible] = useState(false)

  const isShowValue = current?.booleanStruct?.showValue === 2 ? 'true' : false
  const isMulti = current?.memberStruct?.isMulti
  const dateType = current?.dateStruct?.viewType

  const onChangePropertyName = (value) => {
    if (!value || /[\^|=]/.test(value)) {
      message.warning('属性名称不能为空，且不能包含字符「^」和「=」')
      return
    }
    let flag
    propsList.forEach((prop) => {
      if (prop.propertyId !== propertyId && value && prop.propertyName === value) {
        flag = true
        return message.warning('属性名称不能重复')
      }
    })
    if (flag) {
      globalFlag = true
    } else {
      globalFlag = false
    }
    current.propertyName = value
    setPropsList(pre => [...pre])
  }
  const onChangePropertyType = (value) => {
    let defaultOption
    if (value === TYPE.BOOL || value === TYPE.MEMBER) defaultOption = false
    if (value === TYPE.DATE) defaultOption = DATE_VIEW.YEAR
    current.propertyType = value
    onChangeOptions(value, defaultOption)
    setPropsList(pre => [...pre])
  }
  const onChangeOptions = (type, value) => {
    setShowEditList(false)
    if (type === TYPE.BOOL) {
      delete current.memberStruct
      delete current.dateStruct
      delete current.multiStruct
      delete current.singleStruct
      current.booleanStruct = { showValue: value ? 2 : 1 }
    }
    if (type === TYPE.MEMBER) {
      delete current.booleanStruct
      delete current.dateStruct
      delete current.multiStruct
      delete current.singleStruct
      current.memberStruct = { isMulti: value }
    }
    if (type === TYPE.DATE) {
      delete current.booleanStruct
      delete current.memberStruct
      delete current.multiStruct
      delete current.singleStruct
      current.dateStruct = { viewType: value }
    }
    if (type === TYPE.SINGLE) {
      delete current.dateStruct
      delete current.booleanStruct
      delete current.memberStruct
      delete current.multiStruct
      current.singleStruct = { rootItems: cloneDeep(ITEM_LIST) }
    }
    if (type === TYPE.MULTIPLE) {
      delete current.dateStruct
      delete current.booleanStruct
      delete current.memberStruct
      delete current.singleStruct
      current.multiStruct = { rootItems: cloneDeep(ITEM_LIST) }
    }
    setPropsList(pre => [...pre])
  }
  return <div className="module" style={{ borderLeft: '1px solid var(--m-line-1)' }}>
    <div className="header">
      <span className="title">编辑属性</span>
      <div className="meinian-space" />
      {isFixed ? null : <div
        className="delete-btn"
        onClick={() => { setVisible(true) }}
      >
        <Icon type="m-shanchu" style={{ marginRight: 2 }} />删除属性
      </div>}
      <Modal
        className="mn-update-property-attention-modal"
        centered
        width={480}
        visible={visible}
        hiddenCloseIcon
        style={{ width: 416, minHeight: 188 }}
        onCancel={() => setVisible(false)}
        footer={<>
          <Button onClick={() => setVisible(false)} style={{ marginRight: 12 }}>取消</Button>
          <Button
            type="primary"
            style={{ width: 200 }}
            onClick={() => {
              onRemoveProperty(propertyId)
              setVisible(false)
            }}
          >我已明白风险，确认删除</Button>
        </>}
      >
        <div className="property-desc-wrap">
          <Icon type="m-zhuyi_tianchong" style={{ fontSize: 24, color: '#ED7E28' }} />
          <div className="description">
            <div className="title">确认删除 「{propertyName || '新属性'}」?</div>
            <div className="text">
              删除后不可恢复，请谨慎操作!
            </div>
          </div>
        </div>
      </Modal>
    </div>
    <div className="props-wrap" style={{ maxHeight: 'none' }}>
      <div className="section">
        <span className="item-title">属性名称<i style={{ color: 'red' }}>*</i></span>
        <Input
          placeholder="请输入属性的名称，比如款式材质"
          wrapClassName="property-name-input"
          wrapStyle={{ backgroundColor: isFixed ? 'var(--m-fill-1)' : '' }}
          style={{ cursor: isFixed ? 'not-allowed' : 'default' }}
          maxLength={6}
          showCount
          disabled={isFixed}
          value={propertyName || ''}
          onChange={(e) => { onChangePropertyName(e.target.value) }}
        />
      </div>
      {/* 一般属性的属性类型也不能修改，除新建外 */}
      <div className="section">
        <span className="item-title">属性类型<i style={{ color: 'red' }}>*</i></span>
        <Select
          placeholder="选择属性的类型"
          disabled={propertyType || isFixed || !tempId}
          value={propertyType}
          onChange={(value) => { onChangePropertyType(value) }}
        >
          {PROPS_TYPE.map(item => <Option value={item.type}>{item.label}</Option>)}
        </Select>
      </div>
      {propertyType === TYPE.BOOL || propertyType === TYPE.MEMBER ? <div className="options-setting">
        <Checkbox checked={isShowValue || isMulti} onChange={(e) => { onChangeOptions(propertyType, e.target.checked) }} />
        <span className="options">{propertyType === TYPE.BOOL ? '显示为有/无' : '允许多选'}</span></div> : null}
      {(propertyType === TYPE.SINGLE || propertyType === TYPE.MULTIPLE) && <div className="options-setting" onClick={() => onClick()}>
        <div className="meinian-space" />
        {showEditList ? '收起' : '设置选项'}
        <Icon type={showEditList ? 'm-xiangzuo' : 'm-Vxing_you'} />
      </div>}
      {propertyType === TYPE.DATE ? <div className="date-view-wrap">
        <div className="date-select-wrap">
          <span className="title">日期视图</span>
          <Radio.Group value={dateType} onChange={(e) => { onChangeOptions(propertyType, e.target.value) }}>
            <Radio value={DATE_VIEW.YEAR}>年视图</Radio>
            <Radio value={DATE_VIEW.MONTH}>月视图</Radio>
            <Radio value={DATE_VIEW.DAY}>日视图</Radio>
          </Radio.Group>
        </div>
        <div className="date-view">
          <img src={dateType === DATE_VIEW.YEAR ? yearImg : dateType === DATE_VIEW.MONTH ? monthImg : dayImg} />
        </div>
      </div> : null}
    </div>
  </div>
}
const ITEM_LIST = [
  {
    childItems: [],
    value: '',
  },
  {
    childItems: [],
    value: '',
  },
  {
    childItems: [],
    value: '',
  }
]
const AddItemList = (props) => {
  const { current, defaultList, setPropsList } = props
  const { propertyType, propertyName } = current
  const [itemList, setItemList] = useState([])
  const $listBottom = useRef()

  console.log('current', current)

  useEffect(() => {
    if (itemList.length === 0) return
    if (propertyType === TYPE.SINGLE) {
      current.singleStruct.rootItems = itemList
    }
    if (propertyType === TYPE.MULTIPLE) {
      current.multiStruct.rootItems = itemList
    }
    setPropsList(pre => [...pre])
  }, [itemList])
  useEffect(() => {
    if (propertyType === TYPE.SINGLE) {
      const list = current?.singleStruct?.rootItems
      setItemList(convert(list))
    }
    if (propertyType === TYPE.MULTIPLE) {
      const list = current?.multiStruct?.rootItems
      setItemList(convert(list))
    }
  }, [current])

  const onAddItem = () => {
    if (itemList.length >= 99) return message.warning('最多添加99条选项')
    const item = { node: 1, childItems: [], value: '', key: `${iTreeKey++}` }
    itemList.push(item)
    convert(itemList)
    setItemList(pre => [...pre])
    $listBottom.current.scrollIntoView()
  }
  const onClear = () => {
    Modal.show({
      hiddenCloseIcon: true,
      style: { width: 416, minHeight: 152 },
      className: 'mn-update-property-attention-modal',
      children: <div className="property-desc-wrap">
        <Icon type="m-zhuyi_tianchong" style={{ fontSize: 24, color: '#ED7E28' }} />
        <span className="description">确认清空选项，清空后非默认属性不可恢复？</span>
      </div>,
      onOk: () => {
        if (propertyType === TYPE.SINGLE) {
          current.singleStruct.rootItems = []
        }
        if (propertyType === TYPE.MULTIPLE) {
          current.multiStruct.rootItems = []
        }
        setItemList([])
      }
    })
  }
  const onChangeToDefult = () => {
    const itemList = defaultList.find(item => item.propertyName === propertyName)
    Modal.show({
      hiddenCloseIcon: true,
      style: { width: 416, minHeight: 152 },
      className: 'mn-update-property-attention-modal',
      children: <div className="property-desc-wrap">
        <Icon type="m-zhuyi_tianchong" style={{ fontSize: 24, color: '#ED7E28' }} />
        <span className="description">确认恢复为修改前的选项?</span>
      </div>,
      onOk: () => {
        if (propertyType === TYPE.SINGLE) {
          current.singleStruct.rootItems = itemList.singleStruct.rootItems
          setItemList([...convert(itemList.singleStruct.rootItems)])
        }
        if (propertyType === TYPE.MULTIPLE) {
          current.multiStruct.rootItems = itemList.multiStruct.rootItems
          setItemList([...convert(itemList.multiStruct.rootItems)])
        }
      },
    })
  }
  return <div className="module" style={{ borderLeft: '1px solid var(--m-line-1)' }}>
    <div className="header">
      <div className="meinian-space" />
      <div className="add-item-btn" onClick={() => { onAddItem() }}><Icon type="m-tianjia" />添加选项</div>
      <span className="clear" onClick={() => onClear()}>清空</span>
      {current.isFixed ? <span className="revert" onClick={() => onChangeToDefult()}>恢复系统默认</span> : null}
    </div>
    <div className="content-wrap">
      <TreeList
        data={itemList}
        setData={setItemList}
        onChange={(flag) => {
          if (flag) {
            globalValueFlag = true
          } else {
            globalValueFlag = false
          }
        }}
      />
      <div style={{ width: '100%', height: 72 }} ref={$listBottom} />
    </div>
  </div>
}
